import React from "react";
import { LineChart, Line, ResponsiveContainer } from "recharts";

export default function KeywordSparkline({ data = [], color = "#b87333" }) {
  if (!data.length) return <span className="text-gray-600 text-xs">—</span>;

  // Invert position so rising = line going up
  const chartData = data.map((d) => ({
    val: d.position ? 100 - d.position : 0,
  }));

  return (
    <div className="w-20 h-8">
      <ResponsiveContainer width="100%" height="100%">
        <LineChart data={chartData}>
          <Line
            type="monotone"
            dataKey="val"
            stroke={color}
            strokeWidth={1.5}
            dot={false}
          />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
}
